import React from "react";

const postCard = ({ post, navigate }) => {
  return (
    <div
      onClick={() => navigate(`/postDetails/${post?._id}`)}
      className="card w-full glass"
    >
      {/* <figure>
        <img src={`${post?.image}`} alt={`${post?.title}`} />
      </figure> */}
      <div className="card-body">
        <h2 className="card-title">{post?.title?.substring(0, 80)}...</h2>

        <h3 className="text-xl ">
          {post?.category} || {post?.sourceName}
        </h3>
        <h3 className="font-semibold text-sm">
          {post?.date + " "} {post?.time}
        </h3>
        <p>{post?.description?.substring(0, 80)}...</p>
      </div>
    </div>
  );
};

export default postCard;
